export default "__VITE_ASSET__DikBkFgt__"